import TeamToken from '@admin/tokens/team'
import Page from '@admin/components/page'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'

const mapPropsToPage = (props, context) => ({
  title: 't(Subscriptions)',
  access: { rights: { $allOf: ['dashboards:access_app','truevail:access_app'] } },
  collection: {
    endpoint: '/api/admin/dashboards/truevail/statuses',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'team.title', sort: 'team', primary: true, format: TeamToken },
      { label: 't(Duration)', key: 'started_at', primary: true, collapsing: true, align: 'right', format: (team) => (
        <>{ numeral(moment(props.params.end_date).diff(moment(team.started_at), 'hours') / 24).format('0.00') }</>
      ) }
    ],
    defaultSort: { key: 'title', order: 'asc' },
    empty: {
      svg: 'square_check',
      title: 't(No Signups)',
      text: 't(No one has signed up yet)'
    },
    entity: 'team',
    onClick: (record) => {
      if(record.entity.type === 'agency') context.router.push(`/admin/truevail/admin/agencies/${record.entity.agency_id}`)
      if(record.entity.type === 'advisor') context.router.push(`/admin/truevail/admin/advisors/${record.entity.advisor_id}`)
      if(record.entity.type === 'supplier') context.router.push(`/admin/truevail/admin/suppliers/${record.entity.supplier_id}`)      
    }
  }
})

export default Page(null, mapPropsToPage)
